<!-- Sits beside the status dropdown in the navbar, so it is reachable from all four steps and from
     the review screen. -->
<button *ngIf="canShare" kendoButton class="shareBtn shareBtn--inline"
    [disabled]="!loanApplicationId"
    (click)="open()">Share with customer</button>

<kendo-dialog *ngIf="dialogOpened" title="Share this file with the customer"
    (close)="close()" [minWidth]="250" [width]="620">

    <div class="share-dialog">

        <p class="share-intro">
            Invited customers get view-only access. They can see the file, download its documents and
            leave notes, but cannot change anything.
        </p>

        <!-- Everyone on step 1, shown for confirmation only. There is no per-person button: the
             borrower and co-borrower are always invited together, and the server ignores any single
             address, so one button sends to all of them. -->
        <div class="share-recipients" *ngIf="!loading && hasRecipients">
            <h4 class="share-heading">The invite will be sent to</h4>

            <div class="share-row" *ngFor="let recipient of recipients">
                <div class="share-row-who">
                    <div class="share-row-top">
                        <span class="share-row-name">{{ recipient.name || 'Borrower' }}</span>
                        <span class="share-row-tag">
                            {{ recipient.type === 'coborrower' ? 'Co-borrower' : 'Borrower' }}
                        </span>
                        <span class="share-row-state" *ngIf="isSharedWith(recipient.email)">Invited</span>
                    </div>
                    <div class="share-row-email" [title]="recipient.email">{{ recipient.email }}</div>
                </div>
            </div>

            <div class="share-actions">
                <button kendoButton type="button" class="btn-proceed k-outline-none"
                    [disabled]="sharing" (click)="share()">
                    {{ shareButtonLabel }}
                </button>
            </div>

            <p class="share-hint">
                Each person gets their own invite and signs in with their own customer portal account.
                To use a different address, change it on step 1.
            </p>
        </div>

        <!-- Step 1 has no email on it, so there is no one to invite and nothing to type instead. -->
        <p *ngIf="!loading && !hasRecipients" class="share-empty share-empty--blocked">
            This file has no borrower email on step 1, so it cannot be shared yet.
            Add the borrower's email address on step 1, then share from here.
        </p>

        <!-- Who it is already shared with. A plain table rather than a kendo-grid: this is one to
             three rows, and every grid in this app is page-level. -->
        <div class="share-existing">
            <h4>Shared with</h4>

            <p *ngIf="loading" class="share-empty">Loading…</p>

            <p *ngIf="!loading && !shares.length" class="share-empty">
                This file has not been shared with anyone yet.
            </p>

            <table *ngIf="!loading && shares.length" class="table share-table">
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>Status</th>
                        <th>Invited</th>
                        <th>Last viewed</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let share of shares">
                        <td>{{ share.recipient_email }}</td>
                        <td>
                            {{ statusLabel(share) }}
                            <!-- An invite that never left the building. The share is real, so the
                                 fix is the resend button above, which re-sends to everyone. -->
                            <span *ngIf="!share.datetimeinvitesent" class="share-warning"
                                title="The invite email has not been sent yet.">!</span>
                        </td>
                        <td>{{ share.datetimecreated | date:'MM/dd/yyyy hh:mm a' }}</td>
                        <td>{{ share.datetimelastaccessed ? (share.datetimelastaccessed | date:'MM/dd/yyyy hh:mm a') : '—' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>

    <kendo-dialog-actions>
        <button kendoButton class="btn-cancel k-outline-none" (click)="close()">Close</button>
    </kendo-dialog-actions>
</kendo-dialog>
